import { useEffect, useState } from "react"
import UserService from "services/user.service"
import { DEFAULT_SEASON_YEAR } from "utils/seasonYear"

const service = new UserService()

export const useLocation = (year?: string) => {
  const [locations, setLocations] = useState<any>([])
  const [loading, setLoading] = useState(false)
  const [totalItems, setTotalItems] = useState(0)

  useEffect(() => {
    setLoading(true)
    service
      .getRecruiterLocations({ year: year || DEFAULT_SEASON_YEAR })
      .then((resp) => {
        setLocations(resp.data.data)
        setTotalItems(resp.data.data.length)
      })
      .catch((error) => {
        console.error(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [year])

  return {
    locations,
    setLocations,
    loading,
    setLoading,
    totalItems,
  }
}
